<template>
  <div @mouseenter="mouseoverDirection" @mouseleave="mouseleaveDirection2"
       :class="lunBo == 0?'btn':lunBo == 1?'btn btn2':'btn btn3'"
       :style="direction?' background-color: white !important;opacity: 1; color: #12466e;':''">
    <div class="btnn">
      <div class="lang-box">
        <el-image v-show="lunBo ==2 && direction" :src="logoL"
                  style="height: 55px;width: 60px;margin-left: 10px"></el-image>
        <el-image v-show="lunBo ==2 && !direction" :src="logoB"
                  style="height: 55px;width: 60px;margin-left: 10px"></el-image>
        <el-image v-show="lunBo != 2" :src="logoB2"
                  style="height: 30px;width: 33px;padding-top: 2px;margin-left: 18px"></el-image>
      </div>
      <div class="lang-box2">
        <div @mouseenter="addBtnClass(index)" @mouseleave="removeBtnClass(index)" class="lang-box2-btn" ref="btnRef"
             v-for="(item,index) in store.state.navigationBar"
             @click="store.commit('gotoUrl',{url:item.url,bar:item.title,barTitleUrl:item.url})">
          <div
              :class="store.state.bar == item.url?'btnText2':'btnText animate__animated animate__faster__btn '">
            {{ item.title }}
          </div>
          <el-tooltip v-if="index == store.state.navigationBar.length-1" :show-arrow="false" placement="bottom"
                      effect="light">
            <div>
              <svg t="1718680250040" class="icon"
                   viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                   :class="lunBo ==2 && !direction?'icon2':'icon1'" p-id="14084" width="30" height="30">
                <path
                    d="M579.2 478.4h-9.6l36.8 206.4c24.8-8.8 47.2-21.6 66.4-39.2-20-24.8-36.8-52-49.6-80.8l39.2-4.8c10.4 21.6 23.2 41.6 36.8 58.4 28.8-35.2 51.2-81.6 66.4-140.8l-186.4 0.8z m148 167.2c22.4 19.2 48 33.6 76 42.4l17.6 5.6-10.4 38.4-17.6-5.6c-34.4-10.4-65.6-28.8-92.8-52.8-24.8 22.4-54.4 40-86.4 50.4l24.8 139.2H490.4l-20 91.2h467.2c21.6 0 40-17.6 40-40V240c0-21.6-17.6-40-40-40H520l31.2 172.8-0.8-0.8 3.2 19.2 0.8-2.4 8.8 49.6h96v-40h74.4v40h124v40h-52c-16.8 69.6-44 125.6-78.4 167.2z m-277.6 217.6H87.2c-44 0-79.2-36-79.2-79.2V108.8c0-44 36-79.2 79.2-79.2h396.8l24.8 131.2h428c44 0 79.2 36 79.2 79.2v675.2c0 44-36 79.2-79.2 79.2H420.8l28.8-131.2zM262.4 557.6v-41.6H184v-61.6h72.8v-41.6H184V360h78.4v-41.6H137.6v238.4h124.8v0.8z m191.2 0V438.4c0-21.6-4.8-38.4-14.4-49.6-9.6-12-24.8-17.6-44-17.6-11.2 0-21.6 2.4-30.4 6.4-8.8 4.8-16 12-20 20h-2.4l-6.4-23.2h-34.4v182.4h44.8V471.2c0-21.6 3.2-36.8 8.8-46.4 5.6-8.8 14.4-13.6 27.2-13.6 8.8 0 16 3.2 20 9.6 4 6.4 6.4 16 6.4 29.6v107.2h44.8z"
                    p-id="14085"></path>
              </svg>
            </div>
            <template #content>
              <div>
                <div @click="setZhongYing()" class="zi">中文</div>
              </div>
            </template>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
  <div @mouseleave="mouseleaveDirection" v-show="direction && direction2 !=0" class="zibtn"
       :style="lunBo == 1 ?'padding-top: 50px;':'padding-top: 90px;'">
    <div style="border-top: #989898 1px solid"></div>
    <div v-for="(item,index) in store.state.navigationBar" v-show="direction2 == index" class="zibtnDiv">
      <div v-if="store.state.navigationBar[index] != null"
           v-for="(item2,index2) in store.state.navigationBar[index].bar"
           :style="store.state.navigationBar[index].bar[index2].list != []?'width:100%;padding:0px;':''" class="zibtnD">
        <div
            @click="store.commit('gotoUrl',{url:item2.url,bar:store.state.navigationBar[index].title,barTitleUrl:item.url})"
            style="width: 100%;display: flex;align-items: center">
          <el-image class="you" :src="you"></el-image>
          <span class="barzi">{{ item2.name }}</span>
        </div>
        <div
            @click="store.commit('gotoUrl',{url:item3.url,bar:store.state.navigationBar[index].title,barTitleUrl:item.url})"
            class="barzi2" v-for="(item3,index3) in store.state.navigationBar[index].bar[index2].list">
          {{ item3.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {inject, onMounted, defineEmits, defineProps, ref, reactive, getCurrentInstance, onDeactivated} from 'vue';
import {useRouter} from "vue-router";
import store from "@/store";
import logoB from '@/assets/logo/logo白.png'
import logoB2 from '@/assets/logo/logo白2.png'
import logoL from '@/assets/logo/logo蓝.png'
import you from '@/assets/you.png'
import zhong from '@/assets/中文.png'
import ying from '@/assets/英文.png'
import 'animate.css';

let direction = ref(false)
let direction2 = ref(0)
const router = useRouter();
let barList = ref([])
let lunBo = ref(0)
let btnRef = ref()
const setZhongYing = () => {
  window.location.href = (window.location.protocol + '//' + window.location.host + window.location.pathname.slice(3) + window.location.search)
}
const mouseleaveDirection = () => {
  direction.value = false;
}
const mouseleaveDirection2 = () => {
  if (direction2.value == 0) {
    direction.value = false;
  }
}
const mouseoverDirection = () => {
  direction.value = true;
  direction2.value = 0;
}

const handleScroll = () => {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollTop > 0) lunBo.value = 1;
  if (scrollTop == 0) lunBo.value = 2;
}
const addBtnClass = (index) => {
  direction2.value = index
  if (btnRef.value[index].childNodes[0].className.indexOf('btnSuo') > -1) {
    return false;
  }
  btnRef.value[index].childNodes[0].classList.add('animate__fadeOutUp', 'btnTextColor')
  btnRef.value[index].childNodes[0].addEventListener('animationend', () => {
    btnRef.value[index].childNodes[0].classList.remove('animate__fadeOutUp')
    btnRef.value[index].childNodes[0].classList.add('animate__fadeInUp', 'btnSuo', 'btnTextColor')
  });
}
const removeBtnClass = (index) => {
  btnRef.value[index].childNodes[0].classList.remove('animate__fadeInUp')
  btnRef.value[index].childNodes[0].classList.add('animate__fadeOutDown', 'btnTextColor')
  btnRef.value[index].childNodes[0].addEventListener('animationend', () => {
    btnRef.value[index].childNodes[0].classList.remove('animate__fadeOutDown', 'btnTextColor')
    btnRef.value[index].childNodes[0].classList.add('animate__fadeInDown')
    btnRef.value[index].childNodes[0].classList.remove('btnSuo')
  });
}
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll()


})
onDeactivated(() => {
  window.removeEventListener('scroll', handleScroll, true);
})

</script>

<style scoped lang="less">
.none {
  display: none !important;
}

.btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  position: fixed;
  top: 0px;
  z-index: 10000;
  color: white;
}

.btnN {
  background-color: white !important;
  opacity: 1;
  color: #12466e;
}

.btnn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  z-index: 5000;
  padding: 20px;
  box-sizing: border-box;
}


.btn2 {
  background-color: rgba(255, 255, 255, 1);
  height: 50px;
  animation: btnDong 1s;
  position: fixed;
  top: 0px;
  color: #12466e;
}

.btn3 {
  background-color: transparent;
  height: 90px;
  position: fixed;
  top: 0px;
  animation: btnDong2 1s;
  opacity: 1;
}

@keyframes btnDong {
  0% {
    background-color: transparent;
    height: 90px;
  }
  100% {
    background-color: rgba(255, 255, 255, 1);
    height: 50px;
  }
}

@keyframes btnDong2 {
  100% {
    background-color: transparent;
    height: 90px;
  }
  0% {
    background-color: white;
    height: 50px;
  }
}

.lang-box {
  position: relative;
  top: 0px;
  z-index: 2000;
}

.lang-box2 {
  margin-left: 20px;
  cursor: pointer;
  position: relative;
  top: 0px;
  z-index: 2000;
}

.lang-box2 {
  display: flex;
  height: 100%;
  align-items: center;
  cursor: pointer
}

.lang-box2-btn {
  display: flex;
  align-items: center;
  padding: 10px 0px;
  box-sizing: border-box
}

.scroll .lang-box {
  border: 1px solid #ddd
}

.lang-box a {
  background: 0 0;
  padding: 0 8px;
  display: inline-block
}

.lang-box a.active, .scroll .lang-box a.active {
  background: #fff;
}

.btnText {
  font-weight: 700;
  margin: 0 20px 0 20px;
  font-size: 18px;
  cursor: pointer;
}

.btnText2 {
  color: #f26228;
  font-weight: 700;
  margin: 0 20px 0 20px;
  font-size: 18px;
  cursor: pointer;
}

.animate__faster__btn {
  --animate-duration: 0.15s;
}

.btnTextColor {
  color: #f26228;
}

.btnH1 {
  position: absolute;
  top: 50%;
  margin: 0 10%;
  transform: translate(0%, -50%);
}

.zibtn {
  position: fixed;
  top: 0;
  background-color: white;
  width: 100%;
  animation: zibtn2 0.5s;
  z-index: 1000;
}

@keyframes zibtn2 {
  100% {
    top: 0px;
  }

  0% {
    top: -100%;
  }
}

.barzi:hover {
  color: #f26228;
}

.barzi2 {
  padding: 15px 30px;
  color: #666666;
  font-weight: 300;
  width: 100%;
  white-space: nowrap;

}

.barzi2:hover {
  color: #f26228;
}

.zibtnD {
  padding: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-wrap: wrap;
}

.zibtnDiv {
  display: flex;
  margin: 0 20%;
  padding: 30px 20px;
  box-sizing: border-box;
  justify-content: space-around;
  color: #555555;
  font-weight: 600;
  align-items: flex-start;
}

.you {
  width: 10px;
  margin-top: 10px;
  margin-right: 10px;
}

.icon1 {
  fill: #12466e;
  margin: 0px 10px;
}

.icon2 {
  fill: white;
  margin: 0px 10px;
}

.zi {
  padding: 8px 13px;
  cursor: pointer;
  font-size: 16px;
}

.zi:hover {
  color: #12466e;
  background-color: #ecf5ff;
}
</style>
